module.exports = __webpack_public_path__ + "static/media/temp_image_viewer.99308e53.jpg";